<template>
  <button class="button-toggle" :data-off="!isDarkMode" @click.prevent="toggleDarkMode">
    <ToggleSwitch :model-value="isDarkMode" @update:model-value="toggleDarkMode" />
    {{ t('dark_mode') }}
  </button>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import { useThemeStore } from '@/stores/theme';
import { useToastStore } from '@/stores/toast';

const { t } = useI18n();
const themeStore = useThemeStore();
const toastStore = useToastStore();

const isDarkMode = ref<boolean>(themeStore.theme === 'dark');

const toggleDarkMode = () => {
  isDarkMode.value = !isDarkMode.value;
  themeStore.updateTheme(isDarkMode.value ? 'dark' : 'light', true);
  toastStore.info(t(isDarkMode.value ? 'toast_dark_mode_on' : 'toast_dark_mode_off'));
};
</script>

<style scoped lang="scss"></style>
